export default {
  name: "নাম",
  tel: "টেলিফোন",
  save: "সংরক্ষণ করুন",
  confirm: "নিশ্চিত করুন",
  cancel: "বাতিল",
  delete: "মুছুন",
  complete: "সমাপ্তি",
  loading: "লোড হচ্ছে ...",
  telEmpty: "আপনার ফোন নম্বর পূরণ করুন",
  nameEmpty: "আপনার নাম পূরণ করুন",
  nameInvalid: "একটি বৈধ নাম লিখুন দয়া করে",
  confirmDelete: "আপনি কি নিশ্চিত যে আপনি এটি মুছতে চান?",
  telInvalid: "সঠিক ফোন নম্বর লিখুন দয়া করে",
  vanCalendar: {
    end: "সমাপ্তি",
    start: "শুরু",
    title: "শিরোনাম",
    confirm: "নিশ্চিত করুন",
    startEnd: "শুরু শেষ",
    weekdays: {
      "0": "দিন",
      "1": "এক",
      "2": "দুই",
      "3": "তিন",
      "4": "চার",
      "5": "পাঁচ",
      "6": "ছয়"
    }
  },
  vanCascader: { select: "নির্বাচন করুন" },
  vanContactCard: { addText: "একটি যোগাযোগ যোগ করুন" },
  vanContactList: { addText: "নতুন যোগাযোগ ব্যক্তি" },
  vanPagination: { prev: "পূর্ববর্তী পৃষ্ঠা", next: "পরবর্তী পৃষ্ঠা" },
  vanPullRefresh: {
    pulling: "রিফ্রেশ করতে টানুন ...",
    loosing: "রিফ্রেশ করুন ..."
  },
  vanSubmitBar: { label: "সমস্ত:" },
  vanCoupon: { unlimited: "ব্যবহারের বিধিনিষেধ নেই" },
  vanCouponCell: { title: "কুপন", tips: "উপলভ্য নয়" },
  vanCouponList: {
    empty: "কোন কুপন নেই",
    exchange: "বিনিময়",
    close: "কোন কুপন নেই",
    enable: "উপলব্ধ",
    disabled: "উপলভ্য নয়",
    placeholder: "দয়া করে ছাড় কোড লিখুন"
  },
  vanAddressEdit: {
    area: "অঞ্চল",
    postal: "ডাক কোড",
    areaEmpty: "একটি অঞ্চল চয়ন করুন",
    addressEmpty: "বিস্তারিত ঠিকানা পূরণ করুন",
    postalEmpty: "ডাক কোড ফর্ম্যাটটি ভুল",
    defaultAddress: "ডিফল্ট শিপিং ঠিকানা হিসাবে সেট করুন",
    telPlaceholder: "মোবাইল নম্বর চালান",
    namePlaceholder: "কনসাইনির নাম",
    areaPlaceholder: "একটি প্রদেশ/শহর/জেলা নির্বাচন করুন"
  },
  vanAddressEditDetail: {
    label: "ঠিকানা",
    placeholder: "রাস্তার দরজা নম্বর, মেঝে রুম নম্বর এবং অন্যান্য তথ্য"
  },
  vanAddressList: { add: "একটি ঠিকানা যোগ করুন" }
};
